import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  position: 'fixed',
  bottom: 100,
  left: 0,
  zIndex: 10,
  pointerEvents: 'none'
};

export const innerContainerStyle: CSSProperties = {
  display: 'flex',
  gap: '4px',
  padding: '6px',
  borderRadius: '30px',
  background: 'rgba(255, 255, 255, 0.65)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  boxShadow:
    '0 4px 16px rgba(0, 0, 0, 0.08), 0 0 0 0.5px rgba(255, 255, 255, 0.5) inset',
  pointerEvents: 'auto',
  boxSizing: 'border-box',
  width: 'calc(100% - 40px)',
  maxWidth: 280
};

export const tabStyle: CSSProperties = {
  flex: '1 1 0',
  minWidth: 0,
  padding: '8px 10px',
  fontSize: '16px',
  fontWeight: '600',
  cursor: 'pointer',
  textAlign: 'center',
  transition: 'all 0.25s ease',
  borderRadius: '30px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const activeTabStyle: CSSProperties = {
  color: '#000',
  background: 'rgba(255, 255, 255, 0.75)',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)'
};

export const inactiveTabStyle: CSSProperties = {
  color: '#000000',
  background: 'transparent'
};
